<template>
    <div class="behavior_box animate__animated animate__fadeIn">
        <div class="behavior">
            <div class="search_box">
                <div class="search_btn" @click="fnOpenEditBehavior('add')"><span>新增诚信行为</span></div>
                <div class="search_btn upload" @click="fnUploadBehaviorCq2" v-if="APP.fnCheckRegion('31')">
                    <span>上传重庆市建委平台</span>
                </div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">人员</div>
                    <div class="title_item">行为类别</div>
                    <div class="title_item">行为描述</div>
                    <div class="title_item">行为发生日期</div>
                    <div class="title_item">奖惩决定内容</div>
                    <div class="title_item">上传时间</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="behaviorList">
                            <div class="box_line" v-for="(item, index) in behaviorList" :key="index">
                                <div class="list_item">{{ fnGetPersonnel(item.personnel_id) }}</div>
                                <div class="list_item">{{ item.type ? '不良行为' : '良好行为' }}</div>
                                <div class="list_item">{{ item.content }}</div>
                                <div class="list_item">{{ item.happenDate }}</div>
                                <div class="list_item">{{ item.mark }}</div>
                                <div class="list_item">
                                    {{ item.upload_at ?  ('已上传至重庆市建委—'+item.upload_at+' ' ): '' }}
                                </div>
                                <div class="list_item">
                                    <div v-if="item.upload_at">
                                        <button class="item_btn blue"
                                            @click="fnOpenEditBehavior(item)"><span>查看</span></button>
                                    </div>
                                    <div v-if="!item.upload_at">
                                        <button class="item_btn blue"
                                            @click="fnOpenEditBehavior(item)"><span>编辑</span></button>
                                    </div>
                                    <div v-if="!item.upload_at">
                                        <button class="item_btn blue"
                                            @click="fnUploadBehaviorCq2(item)"><span>上传</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 添加诚信行为弹窗 -->
            <div class="dialog_behavior" v-if="behaviorWindow">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" :title="behaviorTitle"
                    center :visible.sync="behaviorWindow">
                    <div class="behavior_list">
                        <div class="behavior_item">
                            <div class="reason_body" style="color: #FF0000; padding-left: 20px;">提示：*必填</div>

                            <div class="reason_body">
                                <div class="body_item">人员*</div>
                                <div class="body_item">
                                    <el-select v-model="form.personnel_id" class="select_box"
                                        :popper-append-to-body="false" filterable placeholder="请选择">
                                        <el-option label="请选择" value></el-option>
                                        <el-option v-for="item in personnelList" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="reason_body">
                                <div class="body_item">行为类别*</div>
                                <div class="body_item">
                                    <el-select v-model="form.type" :popper-append-to-body="false" filterable
                                        placeholder="请选择进退场类型">
                                        <el-option key="0" label="良好行为" :value="0"></el-option>
                                        <el-option key="1" label="不良行为" :value="1"></el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="reason_body">
                                <div class="body_item">登记部门</div>
                                <div class="body_item"><input type="text" class="input_box" v-model="form.createDepName"
                                        placeholder="请输入登记部门" /></div>
                            </div>

                            <div class="reason_body">
                                <div class="body_item">登记人姓名*</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" v-model="form.createUserName"
                                        placeholder="请输入登记人姓名" />
                                </div>
                            </div>

                            <div class="reason_body" v-if="form.type == 1">
                                <div class="body_item">行为描述*</div>
                                <div class="body_item">
                                    <el-select v-model="form.creditCode" :popper-append-to-body="false" filterable
                                        placeholder="请选择行为描述">
                                        <el-option v-for="(item, index) in CQ2.badBehavior" :key="index"
                                            :label="item.content" :value="index"></el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="reason_body" v-else>
                                <div class="body_item">行为描述*</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" v-model="form.content" placeholder="请输入行为描述" />
                                </div>
                            </div>

                            <div class="reason_body">
                                <div class="body_item">行为发生日期*</div>
                                <div class="body_item">
                                    <el-date-picker value-format="yyyy-MM-dd" v-model="form.happenDate" type="date"
                                        placeholder="选择日期"></el-date-picker>
                                </div>
                            </div>

                            <div class="reason_body">
                                <div class="body_item">处理部门</div>
                                <div class="body_item"><input type="text" class="input_box" v-model="form.departName"
                                        placeholder="请输入处理部门" /></div>
                            </div>

                            <div class="reason_body">
                                <div class="body_item">处理部门级别</div>
                                <div class="body_item">
                                    <el-select v-model="form.departTypeID" :popper-append-to-body="false" filterable
                                        placeholder="请选择处理部门级别">
                                        <el-option key="101" label="部级" value="101"></el-option>
                                        <el-option key="102" label="省级" value="102"></el-option>
                                        <el-option key="103" label="地市级" value="103"></el-option>
                                        <el-option key="104" label="区县级" value="104"></el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="reason_body">
                                <div class="body_item">奖惩决定内容*</div>
                                <div class="body_item"><input type="text" class="input_box" v-model="form.mark"
                                        placeholder="请输入奖惩决定内容" /></div>
                            </div>

                            <div class="reason_body">
                                <div class="body_item">奖惩决定文号</div>
                                <div class="body_item"><input type="text" class="input_box" v-model="form.fileNum"
                                        placeholder="请输入奖惩决定文号" /></div>
                            </div>

                            <div class="reason_body">
                                <div class="body_item">奖惩日期*</div>
                                <div class="body_item">
                                    <el-date-picker value-format="yyyy-MM-dd" v-model="form.punishDate" type="date"
                                        placeholder="选择日期"></el-date-picker>
                                </div>
                            </div>

                            <div class="reason_body" v-if="form.type == 1">
                                <div class="body_item">处罚截止日期*</div>
                                <div class="body_item">
                                    <el-date-picker value-format="yyyy-MM-dd" v-model="form.punishEDate" type="date"
                                        placeholder="选择日期"></el-date-picker>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="behaviorWindow = false"><span>取消</span></div>
                            <div class="search-btn" v-if="behaviorTitle!='查看诚信行为详情'" @click="fnAddBehavior">
                                <span>保存</span>
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <!-- 上传失败信息弹窗-->
            <div class="dialog_perError" v-if="showErrorInfo">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :modal="false"
                    title="诚信行为上传失败" :visible.sync="showErrorInfo" center>
                    <div class="cont_list">
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="errorInfoList">
                                    <div class="box_line" v-for="(item,index) in errorInfoList" :key="index">
                                        <div class="list_item">{{ item.msg }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showErrorInfo = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        fnRequestPlatform
    } from '@/utils/upload';
    import APP from '@/utils/base';
    import request from '@/utils/request';
    import CQ2 from '@/configure/cq2';
    import {
        Loading
    } from 'element-ui';
    import {
        fnUpload
    } from '@/utils/upload';
    import * as imageConversion from 'image-conversion';
    export default {
        data() {
            return {
                APP: APP,
                CQ2: CQ2,
                showErrorInfo: false, //上传错误弹窗
                errorInfoList: [], // 错误列表
                behaviorTitle: '新增诚信行为', // 弹窗名称
                detailId: '',
                form: {
                    personnel_id: '', // 人员id
                    type: 0, // 行为类别（0:良好行为，1:不良行为）
                    createDepName: '', // 登记部门
                    createUserName: '', // 登记人姓名
                    creditType: '', // 不良行为类别，详见人员不良行为字典表
                    creditCode: '', // 不良行为代码，详见人员不良行为字典表
                    content: '', // 行为描述
                    happenDate: '', // 行为发生日期，格式 yyyy-MM-dd
                    regionNo: '', // 行为发生地行政区划，详见行政区划字典表
                    departName: '', // 处理部门
                    departTypeID: '', // 处理部门级别，详见奖惩部门级别字典表
                    punishEvidence: '', // 处罚依据，详见人员不良行为字典表
                    mark: '', // 奖惩决定内容
                    fileNum: '', // 奖惩决定文号
                    punishDate: '', // 奖惩日期，格式 yyyy-MM-dd
                    punishEDate: '', // 处罚截止日期，格式 yyyy-MM-dd
                },
                formRequired: {
                    personnel_id: '人员',
                    createUserName: '登记人姓名',
                    content: '行为描述',
                    happenDate: '行为发生日期',
                    mark: '奖惩决定内容',
                    punishDate: '奖惩日期',
                },
                behaviorWindow: false, // 添加、编辑诚信行为弹窗
                behaviorList: [], // 诚信行为列表
                personnelList: [], // 项目下人员列表
            };
        },
        created() {
            this.fnGetAllPersonnel();
            this.fnGetBehavior();
        },
        methods: {
            // 上传重庆市建委
            fnUploadBehaviorCq2(_i) {
                fnRequestPlatform({
                        url: '/Cq2/uploadWorkerBehavior',
                        method: 'POST',
                        data: {
                            carry: _i
                        }
                    },
                    res => {
                        this.fnGetBehavior();
                        if (res.code === 1) {
                            this.$message.success(res.data);
                            return;
                        }
                        if (typeof(res.data) !== 'string') {
                            this.errorInfoList = res.data;
                            this.showErrorInfo = true;
                        } else {
                            this.$message.error(res.data);
                        }
                    }
                );
            },

            // 打开新增诚信行为弹窗
            fnOpenEditBehavior(item) {
                if (item != "add") {
                    this.behaviorTitle = item.upload_at ? '查看诚信行为详情' : '编辑诚信行为详情';
                    this.detailId = item.id;
                    this.form.personnel_id = item.personnel_id; // 人员id
                    this.form.type = item.type; // 行为类别（0:良好行为，1:不良行为）
                    this.form.createDepName = item.createDepName; // 登记部门
                    this.form.createUserName = item.createUserName; // 登记人姓名
                    this.form.creditType = item.creditType; // 不良行为类别，详见人员不良行为字典表
                    this.form.creditCode = item.creditCode; // 不良行为代码，详见人员不良行为字典表
                    this.form.content = item.content; // 行为描述
                    this.form.happenDate = item.happenDate; // 行为发生日期，格式 yyyy-MM-dd
                    this.form.regionNo = item.regionNo; // 行为发生地行政区划，详见行政区划字典表
                    this.form.departName = item.departName; // 处理部门
                    this.form.departTypeID = item.departTypeID; // 处理部门级别，详见奖惩部门级别字典表
                    this.form.punishEvidence = item.punishEvidence; // 处罚依据，详见人员不良行为字典表
                    this.form.mark = item.mark; // 奖惩决定内容
                    this.form.fileNum = item.fileNum; // 奖惩决定文号
                    this.form.punishDate = item.punishDate; // 奖惩日期，格式 yyyy-MM-dd
                    this.form.punishEDate = item.punishEDate; // 处罚截止日期，格式 yyyy-MM-dd
                } else {
                    this.behaviorTitle = '新增诚信行为';
                    this.detailId = '';
                    this.form.personnel_id = ''; // 人员id
                    this.form.type = 0; // 行为类别（0:良好行为，1:不良行为）
                    this.form.createDepName = ''; // 登记部门
                    this.form.createUserName = ''; // 登记人姓名
                    this.form.creditType = ''; // 不良行为类别，详见人员不良行为字典表
                    this.form.creditCode = ''; // 不良行为代码，详见人员不良行为字典表
                    this.form.content = ''; // 行为描述
                    this.form.happenDate = ''; // 行为发生日期，格式 yyyy-MM-dd
                    this.form.regionNo = ''; // 行为发生地行政区划，详见行政区划字典表
                    this.form.departName = ''; // 处理部门
                    this.form.departTypeID = ''; // 处理部门级别，详见奖惩部门级别字典表
                    this.form.punishEvidence = ''; // 处罚依据，详见人员不良行为字典表
                    this.form.mark = ''; // 奖惩决定内容
                    this.form.fileNum = ''; // 奖惩决定文号
                    this.form.punishDate = ''; // 奖惩日期，格式 yyyy-MM-dd
                    this.form.punishEDate = ''; // 处罚截止日期，格式 yyyy-MM-dd
                }

                this.behaviorWindow = true;
            },
            // 获取项目下所有人员
            fnGetAllPersonnel() {
                request({
                        url: 'personnel/getAllPersonnel?type=3',
                        method: 'GET'
                    })
                    .then(res => {
                        this.personnelList = res.data;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 按id获取人员
            fnGetPersonnel(_personnelId) {
                for (let key in this.personnelList) {
                    if (this.personnelList[key].id == _personnelId) {
                        return this.personnelList[key].name;
                    }
                }
                return '';
            },
            // 获取所有诚信行为
            fnGetBehavior(_cb) {
                request({
                        url: 'project/getAllRegionExtend',
                        method: 'GET',
                        params: {
                            region: 'cq2_behavior',
                        }
                    })
                    .then(res => {
                        _cb && _cb(res);
                        this.behaviorList = res.data;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 添加诚信行为
            fnAddBehavior() {

                if (this.form.type == 1) {
                    let badBehavior = CQ2.badBehavior[this.form.creditCode]
                    this.form.creditType = badBehavior.creditType
                    this.form.content = badBehavior.content
                }

                for (let key in this.formRequired) {
                    if (!this.form[key]) {
                        return this.$message.warning(this.formRequired[key] + '必填');
                    }
                }

                this.form.region = 'cq2_behavior';

                if (this.detailId != '') {
                    this.form.id = this.detailId
                }

                request({
                        url: 'project/addAllRegionExtend',
                        method: 'POST',
                        data: this.form
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.behaviorWindow = false;
                        this.fnGetBehavior();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';

    .behavior_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .behavior {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .search_box {
        width: 1880px;
        height: 50px;
        margin-top: 24px;
        margin-left: 20px;
        text-align: center;
        font-size: 34px;

        .search_btn {
            width: 166px;
            height: 36px;
            background: url(../../../assets/img/btn_bg_mid.png) no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 40px;
            top: 35px;
            color: #ffffff;
            font-size: 14px;
            cursor: pointer;
            @include flex-box(center, center);

            &.upload {
                width: 180px;
                left: 210px;
            }

            span {
                margin-top: -5px;
            }
        }
    }

    .cont_list {
        margin-top: 29px;
        margin-left: 28px;
        width: 1864px;
        height: 755px;
        border-radius: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .list_title {
            width: 1864px;
            height: 48px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                height: 48px;
                @include flex-box(center, center);

                &:nth-child(1) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(2) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(3) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(4) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(5) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(6) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(7) {
                    width: 267px;
                    margin-right: 30px;
                }
            }
        }

        .list_boxes {
            width: 1864px;
            height: 707px;
            position: relative;
            overflow: hidden;

            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .box_line {
                    width: 1804px;
                    height: 70px;
                    margin: 7px 0 0 30px;
                    font-size: 16px;
                    color: #ffffff;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);

                    .list_item {
                        height: 70px;
                        text-align: center;
                        @include flex-box(center, center);

                        &:nth-child(1) {
                            width: 190px;
                            margin-right: 4px;
                        }

                        &:nth-child(2) {
                            width: 306px;
                            margin-right: 4px;
                        }

                        &:nth-child(3) {
                            width: 286px;
                            margin-right: 4px;
                        }

                        &:nth-child(4) {
                            width: 266px;
                            margin-right: 4px;
                        }

                        &:nth-child(5) {
                            width: 266px;
                            margin-right: 4px;
                        }

                        &:nth-child(6) {
                            width: 266px;
                            margin-right: 4px;
                        }

                        &:nth-child(7) {
                            width: 267px;
                        }

                        span {
                            width: 100%;
                            cursor: pointer;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        div {
                            @include flex-box(center, center);

                            .item_btn {
                                width: 69px;
                                height: 32px;
                                line-height: 32px;
                                margin: 0 2px;
                                font-size: 14px;
                                color: #ffffff;
                                border: none;
                                cursor: pointer;
                                @include flex-box(center, center);

                                &.blue {
                                    background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
                                    background-size: 100% 100%;
                                }

                                &.red {
                                    background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
                                    background-size: 100% 100%;
                                }

                                span {
                                    margin-top: -2px;
                                }
                            }
                        }

                        img {
                            width: 68px;
                            height: 68px;
                        }
                    }
                }
            }
        }
    }

    .dialog_behavior {
        >>>.el-dialog {
            width: 550px;
            height: 670px;
            margin-top: 20vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }

        >>>.el-dialog__body {
            padding: 10px 20px;
        }

        .behavior_list {
            width: 510px;
            height: 520px;
            position: relative;
            overflow: hidden;

            .behavior_item {
                position: absolute;
                left: 0;
                right: -20px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;
            }
        }

        .reason_body {
            width: 510px;
            height: 40px;
            line-height: 40px;
            color: #4db4f4;
            margin: 0 auto;
            @include flex-box();

            .body_item {
                height: 40px;
                color: #ffffff;

                &:first-child {
                    width: 160px;
                    text-align: center;
                }

                &:nth-child(2) {
                    width: 280px;
                }

                .input_box {
                    background-color: rgba(49, 88, 128, 0.6);
                    width: 280px;
                    height: 30px;
                    line-height: 40px;
                    padding-left: 15px;
                    color: #4db4f4;
                    font-size: 12px;
                    border-radius: 2px;
                    outline: none;
                    border: none;

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }

                .select_box {
                    width: 280px;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 2px;
                    background-color: rgba(49, 88, 128, 0.6);
                }

                img {
                    width: 100px;
                    height: 100px;
                }
            }

            >>>.el-input__inner {
                background-color: rgba(49, 88, 128, 0.6);
                width: 280px;
                height: 30px;
                border-radius: 2px;
                border: none;
                color: rgba(77, 180, 244, 0.7);

                /*background: transparent;*/
                &::-webkit-input-placeholder {
                    color: rgba(77, 180, 244, 0.7);
                }

                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: rgba(77, 180, 244, 0.7);
                }
            }

            >>>.el-select__caret {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.el-select-dropdown {
                background-color: rgba(9, 17, 32, 1);
                border: 1px solid rgba(77, 180, 244, 1);
            }

            >>>.popper__arrow {
                border-bottom-color: rgba(77, 180, 244, 1) !important;
            }

            >>>.el-select-dropdown__item {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.el-select-dropdown__item:hover {
                color: #409eff;
            }

            >>>.el-select-dropdown__item.hover {
                color: #409eff;
            }

            >>>.el-input__icon {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.avatar-uploader {
                line-height: 100px;
                margin-right: 10px;

                img {
                    width: 98px;
                    height: 98px;
                    border-radius: 2px;
                }
            }

            >>>.el-upload--picture-card {
                background-color: transparent;
            }

            >>>.el-upload {
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
        }

        .btn_line {
            @include flex-box(center, center);
        }
    }

    // 弹窗公共样式
    .dialog_perError {
        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-dialog {
            width: 910px;
            height: 600px;
            // margin-top: 20vh!important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4DB4F4;
        }

        >>>.el-dialog__title {
            color: #4DB4F4;
        }

        >>>.el-dialog__close {
            color: #4DB4F4;
        }
    }

    .dialog_perError {
        >>>.el-dialog {
            width: 900px;
            height: 600px;
            // margin-top: 20vh!important;
        }

        .cont_list {
            width: 840px;
            height: 425px;
            color: #FFFFFF;
            font-size: 16px;
            border-radius: 10px;
            margin: 0;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 840px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    height: 48px;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        width: 154px;
                        margin: 0 4px 0 30px;
                    }

                    &:nth-child(2) {
                        width: 156px;
                        margin-right: 4px;
                    }

                    &:nth-child(3) {
                        width: 460px;
                        margin-right: 30px;
                    }
                }
            }

            .list_boxes {
                width: 780px;
                height: 377px;
                margin-left: 30px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 780px;
                        height: 70px;
                        margin: 5px 0 0 0px;
                        border-bottom: 1px dashed #1D4495;
                        @include flex-box(flex-start, center);

                        &:hover {
                            background-color: rgba(49, 88, 128, 0.4);
                        }

                        .list_item {
                            color: #F56C6C;
                            height: 70px;
                            text-align: center;
                            @include flex-box(center, center);

                            &:nth-child(1) {
                                width: 780px;
                            }

                            img {
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                            }

                            span {
                                width: 100%;
                                cursor: pointer;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Behavior/BehaviorCq2/index.vue